var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("rwm-tooltip " + _vm.position)},[_c('div',{staticClass:"rwm-tooltip__container"},[_c('p',{staticClass:"rwm-text-fields",domProps:{"innerHTML":_vm._s(_vm.text)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }